module.exports = __webpack_public_path__ + "img/underline-square.7b33c515.svg";